import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageZh() {
    return (
//         <div className="privacy-policy-container">
// <h1>隐私政策</h1>
// <p>最后更新日期：2024年1月18日</p>

// <p>本隐私声明适用于Yuzult（"我们"、"我们"或"我们的"），描述了当您使用我们的服务（"服务"）时，我们如何以及为什么可能会收集、存储、使用和/或共享（"处理"）您的信息，例如：</p>
// <ul>
//     <li>下载并使用我们的移动应用程序（Tasbih Dhikr）或我们的任何其他与本隐私声明相关联的应用程序</li>
//     <li>以其他相关方式与我们互动，包括销售、营销或活动</li>
// </ul>
// <p>有问题或担忧吗？阅读本隐私声明将帮助您了解您的隐私权和选择。如果您不同意我们的政策和做法，请不要使用我们的服务。</p>

// <h2>关键要点摘要</h2>
// <p>本摘要提供了我们隐私声明的关键要点，但您可以通过单击每个关键要点后面的链接或使用下面的目录找到您要查找的部分的更多详细信息。</p>


// <h2>目录</h2>
// <ol>
//     <li>我们收集什么信息？</li>
//     <li>我们如何处理您的信息？</li>
//     <li>我们依赖哪些法律基础来处理您的个人信息？</li>
//     <li>何时以及与谁分享您的个人信息？</li>
//     <li>我们将保留您的信息多长时间？</li>
//     <li>我们如何保护您的信息安全？</li>
//     <li>您的隐私权利是什么？</li>
//     <li>不跟踪功能的控制</li>
//     <li>美国居民是否有特定的隐私权利？</li>
//     <li>我们是否会更新本通知？</li>
//     <li>如何联系我们有关本通知？</li>
//     <li>如何查看、更新或删除我们从您那里收集的数据？</li>
// </ol>


// <h3>1. 我们收集什么信息？</h3>
// <h4>您向我们披露的个人信息</h4>
// <p>简而言之：我们收集您提供给我们的个人信息。</p>
// <p>当您表达对获取有关我们或我们的产品和服务的信息感兴趣，当您参与服务中的活动，或以其他方式与我们联系时，我们会收集您自愿提供给我们的个人信息。</p>
// <p>敏感信息。我们不处理敏感信息。</p>
// <p>您向我们提供的所有个人信息必须真实、完整和准确，并且您必须在个人信息发生变化时通知我们。</p>

// <h3>2. 我们如何处理您的信息？</h3>
// <p>简而言之：我们处理您的信息以提供、改进和管理我们的服务，与您进行沟通，用于安全和防止欺诈，并遵守法律。我们也可能根据您的同意处理您的信息，用于其他目的。</p>
// <p>我们根据您与我们的服务的互动方式，出于各种原因处理您的个人信息，包括：</p>
// <ul>
//     <li>拯救或保护个人的重要利益。当必要时，我们可能会处理您的信息，以拯救或保护个人的重要利益，例如防止伤害。</li>
// </ul>

// <h3>3. 我们依靠哪些法律依据来处理您的信息？</h3>
// <p>简而言之：仅当我们相信在适用法律下有有效的法律理由（即法律依据）来处理您的个人信息时，我们才会处理您的个人信息，例如出于您的同意，以遵守法律，提供您进入或履行我们的合同义务所需的服务，保护您的权利，或履行我们的合法业务利益。</p>
// <p>如果您位于欧盟或英国，本部分适用于您。</p>
// <p>《通用数据保护条例》（GDPR）和英国《通用数据保护条例》（UK GDPR）要求我们解释我们依靠哪些有效的法律依据来处理您的个人信息。因此，我们可能依靠以下法律依据来处理您的个人信息：</p>
// <ul>
//     <li>同意。如果您已经同意，我们可以处理您的信息，以用于特定目的。您可以随时撤回您的同意。</li>
//     <li>法律义务。我们可能会处理您的信息，因为我们认为这是为了遵守我们的法律义务而必要的，例如与执法机构或监管机构合作，行使或捍卫我们的法律权利，或将您的信息披露为我们所涉及的诉讼中的证据。</li>
//     <li>重要利益。我们可能会处理您的信息，因为我们认为这是为了保护您或第三方的重要利益而必要的，例如涉及潜在威胁到任何人安全的情况。</li>
// </ul>
// <p>如果您位于加拿大，本部分适用于您。</p>

// {/* 第3部分的继续 */}
// <p>如果您已经明确同意或者可以推断您同意的情况下，我们可能会处理您的信息，以用于特定目的。您可以随时撤回您的同意。</p>
// <p>在某些特殊情况下，根据适用法律，我们可能有权在没有您的同意的情况下处理您的信息，包括但不限于以下情况：</p>
// <ul>

// <li>如果明显在个人利益之中，且无法及时获得同意</li>
// <li>用于调查、欺诈侦测和预防</li>
// <li>在满足特定条件的情况下用于业务交易</li>
// <li>如果包含在证人陈述中，并且收集对于评估、处理或解决保险索赔是必要的</li>
// <li>用于确认受伤、生病或已故人员的身份，并与直系亲属联系</li>
// <li>如果我们有合理理由相信某人已经、正在或可能成为金融滥用的受害者</li>
// <li>如果合理地预期在获得同意的情况下收集和使用将危及信息的可用性或准确性，且收集是与调查协议违反或违反加拿大或省份法律有关的目的合理的</li>
// <li>如果根据传票、令状、法院命令或与记录制作有关的法院规则的要求进行披露</li>
// <li>如果是由个人在其就业、业务或职业活动中产生的，并且收集与信息产生的目的一致</li>
// <li>如果仅用于新闻、艺术或文学目的</li>
// <li>如果信息是公开可获取的，并且已被法规明确规定</li>

//             </ul>

//                        {/* Section 4 */}
//                        <h3>4. 我们何时与谁分享您的个人信息？</h3>
// <p>简而言之：我们可能会根据本节描述的特定情况分享信息，或与以下第三方分享。</p>
// <p>在以下情况下，我们可能需要分享您的个人信息：</p>
// <ul>
//     <li>业务转让。我们可能会在与公司资产出售、融资或将我们业务的全部或部分收购的谈判期间，或与其他公司的合并有关的情况下分享或转让您的信息。</li>
// </ul>

//  {/* Section 5 */}
// <h3>5. 我们保留您的信息多长时间？</h3>
// <p>简而言之：除非法律另有规定，我们将根据本隐私声明中列明的目的保留您的信息。</p>
// <p>我们仅会在为实现本隐私声明中列明的目的所必需的时间内保留您的个人信息，除非法律要求或允许延长保留期（例如税务、会计或其他法律要求）。</p>
// <p>当我们没有持续的合法业务需要处理您的个人信息时，我们将删除或匿名化这些信息，或者如果不可能进行删除（例如，因为您的个人信息已存储在备份存档中），那么我们将安全存储您的个人信息，并将其与进一步处理隔离，直到可以删除为止。</p>

//  {/* Section 6 */}

// <h3>6. 我们如何保护您的信息安全？</h3>
// <p>简而言之：我们通过一套组织和技术安全措施来保护您的个人信息。</p>
// <p>我们已实施适当和合理的技术和组织安全措施，旨在保护我们处理的任何个人信息的安全。然而，尽管我们采取了保障措施并努力保护您的信息，但不能保证互联网上的电子传输或信息存储技术能够百分之百安全。因此，我们无法承诺或保证黑客、网络犯罪分子或其他未经授权的第三方无法突破我们的安全措施，非法收集、访问、窃取或修改您的信息。尽管我们将尽力保护您的个人信息，但通过我们的服务传输个人信息的风险由您自行承担。您应只在安全环境中访问服务。
// </p>

//             {/* Section 7 */}
//             <h3>7. 您的隐私权利是什么？</h3>
// <p>简而言之：在某些地区，如欧洲经济区（EEA）、英国（UK）、瑞士和加拿大等地，您拥有一些权利，使您更容易访问和控制您的个人信息。您可以随时查看、更改或终止您的帐户。</p>
// <p>在某些地区（如EEA、UK、瑞士和加拿大等地），根据适用的数据保护法律，您可能拥有某些权利。这些权利可能包括以下内容：（i）要求访问和获取您的个人信息的副本；（ii）要求更正或删除；（iii）要求限制个人信息的处理；（iv）在适用情况下，数据可携带性；以及（v）不受自动决策的影响。在某些情况下，您还可能有权反对处理您的个人信息。您可以通过使用下文提供的联系方式与我们联系提出此类请求，联系方式请参阅“如何联系我们有关本通知？”部分。</p>
// <p>撤回您的同意：如果我们依赖于您的同意来处理您的个人信息，根据适用法律，这可能是明示和/或暗示同意，您有权随时撤回您的同意。您可以通过使用下文提供的联系方式随时撤回您的同意。但请注意，这不会影响在撤回之前进行的处理的合法性，也不会影响依法允许的情况下依赖同意之外的合法处理依据进行的个人信息处理。</p>

//             {/* Section 8 */}
//             <h3>8. 关于不跟踪功能的控制</h3>
// <p>大多数网络浏览器以及一些移动操作系统和移动应用程序都包含了一个“Do-Not-Track”（DNT）功能或设置，您可以启用该功能或设置，以表示您的隐私偏好，不希望监视和收集您的在线浏览活动数据。目前尚未最终确定一致的技术标准来识别和实施DNT信号。因此，我们目前不会响应DNT浏览器信号或任何其他自动传达您不希望在线被跟踪的机制。如果未来采用了在线跟踪的标准，我们将在修订版本的隐私政策中通知您相关做法。</p>

//             {/* Section 9 */}
//             <h3>9. 美国居民是否拥有特定的隐私权利？</h3>
// <p>简而言之：如果您是美国居民，您将被授予访问您个人信息的特定权利。</p>
// <p>我们收集哪些个人信息的类别？</p>
// <p>在过去的十二（12）个月中，我们已收集了以下个人信息的类别：</p>
// <table>
//     <tr>
//         <th>类别</th>
//         <th>示例</th>
//         <th>是否收集</th>
//     </tr>
//     <tr>
//         <td>A. 标识符</td>
//         <td>联系方式，例如真实姓名、化名、邮寄地址、电话或移动电话号码、唯一个人标识符、在线标识符、互联网协议地址、电子邮件地址和帐户名称</td>
//         <td>否</td>
//     </tr>
//     <tr>
//         <td>B. 根据州或联邦法律受保护的分类特征</td>
//         <td>性别和出生日期</td>
//         <td>否</td>
//     </tr>

//                 {/* ... Autres catégories ... */}
//                 </table>
// <p>除了上述类别外，我们还可能在以下情况下收集其他个人信息，即当您与我们亲自、在线、通过电话或邮件互动时，包括：</p>

// <ul>
//     <li>通过我们的客户支持渠道获得帮助</li>
//     <li>参与客户调查或竞赛</li>
//     <li>协助提供我们的服务并回应您的询问</li>
// </ul>

// <p>我们如何使用和分享您的个人信息？</p>
// <p>了解我们如何使用您的个人信息，请查看“我们如何处理您的信息？”部分。</p>
// <p>您的信息会与其他人分享吗？</p>
// <p>根据我们与每个服务提供商之间的书面合同，我们可能会向我们的服务提供商披露您的个人信息。了解更多关于我们如何披露个人信息的信息，请查看“我们何时与谁分享您的个人信息？”部分。</p>
// <p>我们可能会出于自身业务目的使用您的个人信息，例如进行技术开发和演示的内部研究。这不被视为“出售”您的个人信息。</p>
// <p>在过去的十二（12）个月中，我们没有披露、出售或与第三方分享任何个人信息以进行商业用途。未来，我们也不会出售或分享属于网站访问者、用户和其他消费者的个人信息。</p>


//             {/* Section 10 */}
//             <h3>10. 我们是否会更新此通知？</h3>
// <p>简而言之：是的，我们将根据相关法律要求定期更新此通知。</p>
// <p>我们可能会不时更新此隐私通知。更新版本将由更新的“修订日期”表示，并且一旦可访问，更新版本将生效。如果我们对此隐私通知进行重大更改，我们可能会通过突出显示此类更改的通知或直接向您发送通知来通知您。我们鼓励您经常查看此隐私通知，以了解我们如何保护您的信息。</p>
 
//  {/* Section 11 */}
// <h3>11. 如何联系我们以了解此通知？</h3>
// <p>如果您对此通知有任何疑问或意见，您可以通过邮寄联系我们：Yuzult</p>

//  {/* Section 12 */}

// <h3>12. 如何查看、更新或删除我们从您那里收集的数据？</h3>
// <p>根据您所在国家/地区的适用法律，您可能有权请求访问我们从您那里收集的个人信息，更改这些信息或删除它。要请求查看、更新或删除您的个人信息，请填写并提交数据主体访问请求。</p>

//         </div>
<div className="privacy-policy-container">
      <h1>塔斯比赫·迪克尔轻应用隐私政策</h1>
      <p>最后更新：2024年7月30日</p>

      <h2>引言</h2>
      <p>欢迎使用塔斯比赫·迪克尔轻应用。本隐私政策旨在告知您在使用我们的应用时我们如何处理您的数据。此应用中唯一的数据收集是通过Google的广告服务AdMob进行的，我们不主动收集任何个人数据。</p>

      <h2>1. 收集和使用您的个人数据</h2>
      <h3>a. 收集的数据类型</h3>
      <h4>i. 通过AdMob使用数据</h4>
      <p>我们的应用使用AdMob来展示广告。AdMob可能会收集诸如您的IP地址、设备标识符以及您对应用的使用信息等数据。这些信息用于提供和改善广告体验。</p>

      <h3>b. 数据使用</h3>
      <p>AdMob收集的数据用于：</p>
      <ul>
        <li>在应用内提供和个性化广告。</li>
        <li>分析展示广告的效果。</li>
      </ul>

      <h3>c. 用户控制</h3>
      <p>您可以通过设备设置控制您的数据用于个性化广告的使用。</p>

      <h2>2. 数据传输</h2>
      <p>您的信息可能会被传输并存储在您所在国家、省份或国家之外的计算机上，那里的数据保护法可能与您的地区不同。</p>

      <h2>3. 个人数据的披露</h2>
      <p>AdMob收集的数据可能会根据Google的隐私政策和法律要求进行共享。</p>

      <h2>4. 个人数据的安全</h2>
      <p>您的数据安全对我们至关重要。然而，任何通过互联网传输或电子存储的方法都不是100%安全的。</p>

      <h2>5. 链接到其他网站</h2>
      <p>我们的服务可能包含指向其他网站的链接。如果您点击第三方链接，您将被引导到该第三方的网站。</p>

      <h2>6. 本隐私政策的更改</h2>
      <p>我们可能会不时更新我们的隐私政策。我们将通过在本页面上发布新的隐私政策来通知您任何更改。</p>

      <h2>7. 联系我们</h2>
      <p>如果您对本隐私政策有任何疑问，请联系我们。</p>

      <h2>有用的链接</h2>
      <p><a href="https://policies.google.com/privacy">Google隐私政策</a></p>
    </div>
    );
}

export default PrivacyPolicyPageZh;
